var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPuntosInteres2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Beneficios_white",
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 219.452,
    viewBox: "0 0 150 219.452",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f5f5f5;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    className: "cls-1",
    d: "M118.943,170.918a103.746,103.746,0,0,0-17.117-4.358c4-4.7,8.269-9.915,12.553-15.485C138.018,120.352,150,94.751,150,75A75,75,0,1,0,0,75c0,19.86,11.986,45.492,35.621,76.176,4.266,5.539,8.51,10.718,12.5,15.392a103.764,103.764,0,0,0-17.065,4.35C13.224,177.291,9.48,185.841,9.48,191.907s3.744,14.616,21.577,20.984c11.85,4.231,27.445,6.562,43.943,6.562s32.093-2.331,43.943-6.562c17.833-6.368,21.577-14.923,21.577-20.984S136.78,177.291,118.943,170.918ZM12.86,75a62.142,62.142,0,0,1,124.285,0c0,16.586-11.363,40.138-32.861,68.114a419.349,419.349,0,0,1-29.292,33.94,415.946,415.946,0,0,1-29.183-33.721C24.254,115.348,12.86,91.731,12.86,75ZM114.624,200.781c-10.485,3.748-24.579,5.811-39.624,5.811s-29.134-2.063-39.62-5.811c-9.485-3.393-13.04-7.224-13.04-8.875s3.555-5.482,13.04-8.883a102.58,102.58,0,0,1,22.946-4.92c6.983,7.624,11.815,12.351,12.188,12.728l4.5,4.389,4.486-4.389c.373-.364,5.183-5.091,12.144-12.728a102.6,102.6,0,0,1,22.981,4.924c9.5,3.4,13.04,7.246,13.04,8.879S124.122,197.389,114.624,200.781Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    className: "cls-1",
    d: "M171.587,114.777a5.15,5.15,0,0,0-9.784,3.157A31.927,31.927,0,1,1,140.02,97a5.151,5.151,0,1,0,2.765-9.923,42.226,42.226,0,1,0,28.837,27.7Z",
    transform: "translate(-56.315 -51.157)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    className: "cls-1",
    d: "M220.068,108.357l-.046-.046a5.15,5.15,0,0,0-7.261,7.282l.047.046a5.149,5.149,0,1,0,7.282-7.282Z",
    transform: "translate(-119.626 -60.374)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuntosInteres2);
export default __webpack_public_path__ + "static/media/Puntos-interes2.8fa7cf2eba1b9b87430bad691436cc87.svg";
export { ForwardRef as ReactComponent };